import { httpClient } from '../http/httpClient'

export async function enableTable(id: string) {
  const { data } = await httpClient.patch(`/table/${id}/enable`)

  return data
}
